/**
 * 生产环境
 */
const prod = {
	//cookie顶域
	DOMAIN: 'niuxuezhang.cn',
	//api
	API_URL: 'https://account.afirstsoft.cn/api/',
	CLIENT_ID: '9484e30a-ca35-4937-a569-f318f7b78e06', //客户端ID
	CLIENT_SECTET: 'emUoDyKH6Tl4QHkeQfKwd3fAVfFEqLvjVYzpv6Yj' //客户端秘钥
};

/**
 * 开发和测试环境
 */
const dev = {
	//cookie顶域
	DOMAIN: window.location.hostname,
	//api
	API_URL: "https://account-test-api.afirstsoft.cn/api/",
	CLIENT_ID: '94041ed8-6bdb-4e9d-aaf7-50d06cee8a2b',
	CLIENT_SECTET: 'l9PTJISSZPAq3wxHZu3YcV6iaD9J9T3GAzEyuWrr'

};

console.log("process.env.NODE_ENV", process.env.NODE_ENV);

export default process.env.NODE_ENV === "development" ? dev : prod;